import { useState } from 'react';
import { Trophy, Plus } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { ToggleRow } from '@/components/ui/ToggleRow';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { ModuleTogglePanel } from '@/components/dashboard/ModuleTogglePanel';

/**
 * cogs/leveling.py's DashboardConfig only exposes a single master toggle
 * (`_dashboard_get_states` returns `{"_master": ...}`, nothing else) — so
 * "Award XP for voice activity" and "Announce level-ups" below are NOT
 * backed by any Bridge field today, unlike the master switch. They stay
 * visible (real, useful settings a future bot-side change could expose)
 * but disabled, rather than either removing them or letting them fake a save.
 */
export function LevelingPage() {
  const [voiceXp, setVoiceXp] = useState(true);
  const [announceLevelUp, setAnnounceLevelUp] = useState(true);

  return (
    <div className="space-y-6">
      <ModuleTogglePanel module="leveling" title="Leveling" permissionNote="Administrator permission required." />

      <Card>
        <CardHeader title="XP settings" description="Not yet configurable via the Bridge — v18 has no per-guild write path for these today." />
        <div className="divide-y divide-border-subtle opacity-60">
          <ToggleRow title="Award XP for voice activity" checked={voiceXp} onChange={setVoiceXp} disabled />
          <ToggleRow title="Announce level-ups" checked={announceLevelUp} onChange={setAnnounceLevelUp} disabled />
        </div>
      </Card>

      <Card>
        <CardHeader
          title="Role rewards"
          description="Grant a role automatically at a given level, with optional stacking."
          action={<Button variant="primary" size="sm" disabled><Plus size={14} aria-hidden="true" />Add reward</Button>}
        />
        <EmptyState icon={Trophy} title="No role rewards yet" />
      </Card>

      <Card>
        <CardHeader title="Leaderboard" description="All-time and weekly rankings." />
        <EmptyState
          icon={Trophy}
          title="No leaderboard data yet"
          description="A public leaderboard page is also planned for the marketing site (docs/ROADMAP.md V1)."
        />
      </Card>
    </div>
  );
}
